<template>
  <div class="row">
    <div class="col-12 col-lg-6">
      <!--      {{ errors }}-->
      <h5 class="card-title">{{ surveyStore.currentConfig.currentStep.zusatzobjekte.question }}</h5>
      <Field as="select" v-model="surveyStore.data.zusatzobjekte.select" id="zusatzobjekte" name="zusatzobjekte"
             class="form-select" :class="{'is-invalid': errors.zusatzobjekte}">
        <option value="">--- bitte auswählen ---</option>
        <option value="true">Ja</option>
        <option value="false">Nein</option>
      </Field>
      <div v-if="errors.zusatzobjekte" class="invalid-feedback">
        {{ errors.zusatzobjekte }}
      </div>
    </div>
    <div class="col-12 mt-4 form-wrapper" :class="{active: surveyStore.data.zusatzobjekte.select === 'true'}">
      <div class="row">
        <div class="col-12 col-lg-6">
          <h5>Wenn ja, ...</h5>
          <template :key="checkbox.key"
                    v-for="checkbox in surveyStore.currentConfig.currentStep.zusatzobjekte.checkboxes">
            <template v-if="surveyStore.data.zusatzobjekte[checkbox.key]">
              <div class="form-group">
                <div class="form-check">
                  <Field type="checkbox" :name="checkbox.key">
                    <input type="checkbox" v-model="surveyStore.data.zusatzobjekte[checkbox.key].checked"
                           :id="checkbox.key" :value="true" class="form-check-input"/>
                    <label class="form-check-label" :for="checkbox.key">
                      {{ checkbox.label }}
                    </label>
                  </Field>
                </div>
                <div class="form-check ms-4" v-if="surveyStore.data.zusatzobjekte[checkbox.key].checked">
                  <Field type="checkbox" :name="`${checkbox.key}_public`">
                    <input type="checkbox" :id="`${checkbox.key}_public`" value="1" class="form-check-input"
                           v-model="surveyStore.data.zusatzobjekte[checkbox.key].public"/>
                    <label class="form-check-label" :for="`${checkbox.key}_public`">
                      öffentlich, auch für Nicht-Hausgäste
                    </label>
                  </Field>
                </div>
                <div v-if="surveyStore.data.zusatzobjekte[checkbox.key].checked" class="ms-4 mt-3">
                  <label class="form-label mb-1" :for="`${checkbox.key}_zusatz_name`">Name</label>
                  <input
                    :id="`${checkbox.key}_zusatz_name`"
                    v-model="surveyStore.data.zusatzobjekte[checkbox.key].name"
                    type="text"
                    class="form-control"
                    autocomplete="off"
                    :placeholder="`Name für „${checkbox.label}“`"
                  >
                </div>
                <ZusatzobjekteDetails group="zusatzobjekte" :model="checkbox.key"
                                      v-if="surveyStore.data.zusatzobjekte[checkbox.key].value"/>
              </div>
            </template>
            <template v-else>
              missing surveyStore.data.zusatzobjekte[{{ checkbox.key }}]
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useSurveyStore} from "../../../stores/survey";
import {Field} from 'vee-validate';
import ZusatzobjekteDetails from "./ZusatzobjekteDetails";

export default {
  components: {
    ZusatzobjekteDetails,
    Field,
  },
  setup() {
    return {
      surveyStore: useSurveyStore(),
    }
  },
  data() {
    return {}
  },
  props: {
    errors: Object,
  },
  methods: {},

}
</script>
<style scoped lang="scss">
.custom-input {
  width: 40px;
  text-align: center;
}

.form-wrapper {
  position: relative;

  &:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: white;
    opacity: 0.7;
  }

  &.active {
    &:after {
      display: none;
    }
  }
}

</style>
